import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Home, Users, PlusCircle, User, MessageSquare, ShoppingBag, BookOpen, Calendar } from 'lucide-react';

export const MobileNav = () => {
  const { isAuthenticated, isCoach, isAdmin, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) return null;

  const isPureCoach = user?.role === 'coach';
  
  const navItems = isPureCoach ? [
    { href: '/coach', icon: Home, label: 'Dashboard' },
    { href: '/events', icon: Calendar, label: 'Events' },
    { href: '/community', icon: Users, label: 'Community' },
    { href: '/library', icon: BookOpen, label: 'Library' },
  ] : isAdmin ? [
    { href: '/admin', icon: Home, label: 'Admin' },
    { href: '/events', icon: Calendar, label: 'Events' },
    { href: '/community', icon: Users, label: 'Community' },
    { href: '/library', icon: BookOpen, label: 'Library' },
  ] : [
    { href: '/dashboard', icon: Home, label: 'Home' },
    { href: '/events', icon: Calendar, label: 'Events' },
    { href: '/community', icon: Users, label: 'Community' },
    { href: '/library', icon: BookOpen, label: 'Library' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden mobile-nav border-t border-border safe-area-bottom">
      <div className="flex justify-around items-center h-16 px-2">
        {navItems.map(item => {
          const Icon = item.icon;
          const isActive = location.pathname === item.href || 
            (item.href !== '/dashboard' && location.pathname.startsWith(item.href));
          
          return (
            <Link
              key={item.href}
              to={item.href}
              className={`flex flex-col items-center justify-center py-2 px-3 rounded-lg transition-colors touch-target ${
                isActive 
                  ? 'text-primary bg-primary/10' 
                  : 'text-muted-foreground hover:text-foreground'
              }`}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              <Icon className="w-6 h-6" />
              <span className="text-xs font-medium mt-1">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
